import { ChipProps } from "@mui/material";

export const stripeStatusMap: Record<
  string,
  { text: string; color: ChipProps["color"] }
> = {
  paid: { text: "Paid", color: "success" },
  open: { text: "Unpaid", color: "secondary" },
  void: { text: "Void", color: "info" },
  partially_refunded: { text: "Partially refunded", color: "primary" },
  refunded: { text: "Refunded", color: "primary" },
};
